import React from "react";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";

const ProcessDetail = ({ processData, activeIndex, onIndexChange }) => {
  if (!processData || processData.length === 0) {
    return null;
  }

  const currentProcess = processData[activeIndex];
  
  const handlePrevious = () => {
    if (activeIndex > 0 && onIndexChange) {
      onIndexChange(activeIndex - 1);
    }
  };
  
  const handleNext = () => {
    if (activeIndex < processData.length - 1 && onIndexChange) {
      onIndexChange(activeIndex + 1);
    }
  };

  return (
    <div className="w-full h-full lg:w-[450px] lg:h-[70%] relative">
      {/* 왼쪽 화살표 */}
      <button
        onClick={handlePrevious}
        disabled={activeIndex === 0}
        className={`absolute left-2 lg:left-0 top-1/2 -translate-y-1/2 lg:-translate-x-6 z-50 
                   w-10 h-10 lg:w-12 lg:h-12 rounded-full 
                   flex items-center justify-center transition-all duration-300 shadow-lg border border-gray-100
                   ${activeIndex === 0 
                     ? 'bg-gray-100 text-gray-300 cursor-not-allowed opacity-50' 
                     : 'bg-white text-gray-600 hover:bg-red-50 hover:text-red-600 hover:shadow-xl hover:scale-110 cursor-pointer'
                   }`}
      >
        <MdKeyboardArrowLeft size={24} className="lg:w-7 lg:h-7" />
      </button>

      {/* 오른쪽 화살표 */}
      <button
        onClick={handleNext}
        disabled={activeIndex === processData.length - 1}
        className={`absolute right-2 lg:right-0 top-1/2 -translate-y-1/2 lg:translate-x-6 z-50 
                   w-10 h-10 lg:w-12 lg:h-12 rounded-full 
                   flex items-center justify-center transition-all duration-300 shadow-lg border border-gray-100
                   ${activeIndex === processData.length - 1 
                     ? 'bg-gray-100 text-gray-300 cursor-not-allowed opacity-50' 
                     : 'bg-white text-gray-600 hover:bg-red-50 hover:text-red-600 hover:shadow-xl hover:scale-110 cursor-pointer'
                   }`}
      >
        <MdKeyboardArrowRight size={24} className="lg:w-7 lg:h-7" />
      </button>

      <div className="rounded-3xl z-40 bg-white/95 backdrop-blur-md border border-gray-200/30 shadow-xl hover:shadow-2xl transition-all duration-300">
        <div className="pt-8 pb-12 px-6 lg:px-12 space-y-8 lg:space-y-12">
          <div>
            <div className="space-y-6 lg:space-y-8">
              <div className="inline-flex items-center px-3 py-1 rounded-full bg-red-50 text-red-600 text-sm font-medium">
                {currentProcess?.gubun}
              </div>
              
              <div className="text-center">
                <h2 className="text-2xl lg:text-3xl font-bold text-gray-900 leading-tight">
                  {currentProcess?.name}
                </h2>
              </div>
              
              <div className="text-center">
                <p className="text-base lg:text-lg text-gray-600 whitespace-pre-line leading-relaxed font-[SUIT-Regular]">
                  {currentProcess?.title}
                </p>
              </div>
            </div>
          </div>
          
          <div className="pt-6 mt-2 border-t border-gray-200/60">
            <div className="bg-gray-50/50 rounded-2xl p-6">
              <div className="text-base lg:text-lg text-gray-800 leading-8 tracking-wide space-y-3 font-[SUIT-Regular]">
                {currentProcess?.desc?.split('\n').map((line, index) => (
                  <p key={index} className="mb-2 last:mb-0">
                    {line}
                  </p>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProcessDetail; 